// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoCardContainer {
  z-index: 3; /*until the background has its own grain filter instead of the overlay*/
  margin: auto;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3rem;
}

.textContainer {
  width: 400px;
  height: fit-content;
  padding: 24px;
  padding-top: 40px;
  background-color: rgba(0, 48, 73, 0.6);
  border-radius: 24px;
  color: white;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
@media (max-width: 1000px) {
  .textContainer {
    width: 90%;
    margin: 0 5% 24px 5%;
  }
}
.textContainer h5 {
  font-family: "Chakra Petch";
  font-size: 20px;
  text-align: center;
  margin-bottom: 36px;
}
.textContainer p {
  font-size: 16px;
  font-family: "Chakra Petch";
}

.icon {
  width: 60px;
  height: 60px;
  margin-bottom: 32px;
  fill: white;
}

@supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) and (backdrop-filter: blur(30px)) {
  .textContainer {
    background: rgba(0, 48, 73, 0.4);
    box-shadow: inset 0px 4px 20px rgba(255, 255, 255, 0.25), inset 0px -4px 20px rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(30px);
    border-radius: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/InfoCard/InfoCard.scss"],"names":[],"mappings":"AAAA;EACC,UAAA,EAAA,uEAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AACD;;AAEA;EACC,YAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,sCAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,sBAAA;AAAD;AAEC;EAdD;IAeO,UAAA;IACH,oBAAA;EACF;AACF;AAEC;EACC,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAAF;AAGC;EACC,eAAA;EACA,2BAAA;AADF;;AAOA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AAJD;;AAOA;EACC;IACE,gCAAA;IACD,iGAAA;IACA,2BAAA;IACA,mBAAA;EAJA;AACF","sourcesContent":[".infoCardContainer {\r\n\tz-index: 3; \t/*until the background has its own grain filter instead of the overlay*/\r\n\tmargin: auto;\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tmargin-top: 3rem;\r\n}\r\n\r\n.textContainer {\r\n\twidth: 400px;\r\n\theight: fit-content;\r\n\tpadding: 24px;\r\n\tpadding-top: 40px;\r\n\tbackground-color: #00304999;\r\n\tborder-radius: 24px;\r\n\tcolor: white;\r\n\tmargin-bottom: 40px;\r\n\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tflex-direction: column;\r\n\r\n\t@media (max-width: 1000px) {\r\n       width: 90%;\r\n\t   margin: 0 5% 24px 5%;\r\n    }\r\n\r\n\r\n\t& h5 {\r\n\t\tfont-family: \"Chakra Petch\";\r\n\t\tfont-size: 20px;\r\n\t\ttext-align: center;\r\n\t\tmargin-bottom: 36px;\r\n\t}\r\n\r\n\t& p {\r\n\t\tfont-size: 16px;\r\n\t\tfont-family: \"Chakra Petch\";\r\n\r\n\t}\r\n\t\r\n}\r\n\r\n.icon {\r\n\twidth: 60px;\r\n\theight: 60px;\r\n\tmargin-bottom: 32px;\r\n\tfill: white;\r\n}\r\n\r\n@supports (((-webkit-backdrop-filter: none) or (backdrop-filter: none)) and (backdrop-filter: blur(30px)) ) {\r\n\t.textContainer {\r\n\t\t background: rgba(0, 48, 73, 0.4);\r\n\t\tbox-shadow: inset 0px 4px 20px rgba(255, 255, 255, 0.25), inset 0px -4px 20px rgba(0, 0, 0, 0.25);\r\n\t\tbackdrop-filter: blur(30px);\r\n\t\tborder-radius: 12px;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
